import CryptoJS from "crypto-js";

const SECRET = "ShersoftⒷcopyright";

export const encrypt = (text) => {
  return CryptoJS.AES.encrypt(text, SECRET)
    .toString()
    .replace(/\//g, "_");
};

export const decrypt = (cipher) => {
  try {
    cipher = cipher.replace(/_/g, "/");
    const bytes = CryptoJS.AES.decrypt(cipher, SECRET);
    return bytes.toString(CryptoJS.enc.Utf8);
  } catch {
    return "";
  }
};


const map = {
  'Ⓑ': "fullimage"
};

export const shortEncrypt = (text) => {
  // Find if existing
  for (const key in map) {
    if (map[key] === text) return key;
  }

  // Generate new 10-char token
  const token = Array(10)
    .fill(0)
    .map(() =>
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789"
        [Math.floor(Math.random() * 62)]
    )
    .join("");

  map[token] = text;
  return token;
};

export const shortDecrypt = (token) => {
  return map[token] || null;
};
